import {call, putResolve, select, takeLatest} from '@redux-saga/core/effects';
import {createSmartAction} from 'redux-smart-actions';
import {deleteToken, getToken, setToken} from 'api/auth/auth';
import {loginPushUser, logoutPushUser} from 'lib/onesignal';

// Requête dédiée : l'écran Profil lance aussi /me, et une même requête relancée annule la
// précédente (takeLatest de redux-requests).
export const getPushId = createSmartAction(() => ({
  request: {url: '/mco-leclub-api/v1/me'},
  meta: {requestKey: 'push-id', takeLatest: false},
}));

// À la connexion (ou à l'ouverture avec une session), l'abonnement OneSignal du téléphone est
// rattaché au membre ; à la déconnexion, il en est détaché.
function* linkPushUserSaga({type}) {
  try {
    if (type === deleteToken.toString()) {
      yield call(logoutPushUser);
      return;
    }
    const token = yield select(getToken);
    if (!token) return;
    const {data} = yield putResolve(getPushId());
    if (data?.push_id) yield call(loginPushUser, data.push_id);
  } catch (e) {
    console.warn('OneSignal user link failed', e);
  }
}

export function* saga() {
  yield takeLatest(['persist/REHYDRATE', setToken.toString(), deleteToken.toString()], linkPushUserSaga);
}
